function isTouchEvent(event) {
    return event.changedTouches != null;
}
function normalizePointerEvent(e) {
    let isTouch = false;
    let pointerEvent;
    if (isTouchEvent(e)) {
        pointerEvent = e.changedTouches[0];
        isTouch = true;
    } else {
        pointerEvent = e;
    }
    let {clientX, clientY, pageX, pageY} = pointerEvent;
    return {
        clientX,
        clientY,
        pageX,
        pageY,
        isTouch
    };
}

export { isTouchEvent, normalizePointerEvent };
